import * as yup from 'yup';

const useProductFormValidationSchema = () => {
	const stepOneValidation = yup.object({
		name: yup.string().required('Enter Style Name'),
		gender: yup.string().required('Gender is required'),
		type: yup.string().required('Product type is required'),
		styleCollections: yup.array().when('createCollections', {
			is: false,
			then: yup
				.array()
				.min(
					1,
					'Please select at least one collection or click Yes to create collection.'
				)
				.required('Style Collection is required.'),
		}),
		newCollections: yup.array().when('createCollections', {
			is: true,
			then: yup
				.array()
				.min(1, 'Please Add at least one collection')
				.required('Style Collection is required.'),
		}),
	});

	const stepTwoValidation = yup.object({
		type: yup.string().required('Product type is required'),
		sellAbroad: yup.boolean().required('Sell Abroad is required'),
		pricingModel: yup
			.string()
			.oneOf(['FIXED_PRICE', 'BESPOKE'])
			.required('Pricing model is required'),
		variations: yup.array().of(
			yup.object({
				name: yup.string().required('Variation Name is required'),
				sizes: yup.array().of(yup.string()),
				accessories: yup.array().of(yup.string()),
				customColors: yup.array().when('addCustomColor', {
					is: true,
					then: yup
						.array()
						.min(
							1,
							'Please Add at least one Custom color or Select NO for add custom colors above'
						)
						.required('Custom color is required.'),
				}),
				durationInMinutes: yup.number().when(['$type'], {
					is: type => {
						return type === 'SERVICE';
					},
					then: yup
						.number()
						.min(1, 'Please Add how many minutes a session of this service is ')
						.required('Service duration is required.'),
					otherwise: yup.number().optional(),
				}),
				local: yup.object({
					withoutMaterial: yup.number().optional(),
					currencyCode: yup.string().optional(),
					onSaleSlashPrice: yup.number().optional(),
					withMaterial: yup.number().when(['$sellAbroad', '$pricingModel'], {
						is: (sellAbroad, pricingModel) =>
							sellAbroad === false && pricingModel === 'FIXED_PRICE',
						then: yup
							.number()
							.min(1, 'Price (Ready to wear) cannot be zero (0)')
							.required('Price (Ready to wear) is required'),
						otherwise: yup.number().optional(),
					}),
				}),
				international: yup.object({
					currencyCode: yup.string().when(['$sellAbroad', '$pricingModel'], {
						is: (sellAbroad, pricingModel) =>
							sellAbroad === true && pricingModel === 'FIXED_PRICE',
						then: yup
							.string()
							.required('International currency code is required'),
						otherwise: yup.string(),
					}),
					withMaterial: yup.number().when(['$sellAbroad', '$pricingModel'], {
						is: (sellAbroad, pricingModel) =>
							sellAbroad === true && pricingModel === 'FIXED_PRICE',
						then: yup.number().required('International price is required'),
						otherwise: yup
							.number()
							.min(0, 'International price  must be 0 or more'),
					}),
					onSaleSlashPrice: yup
						.number()
						.min(0, 'International Sales must be 0 or more'),
				}),
			})
		),
	});

	const stepThreeValidation = yup.object({
		type: yup.string().required('Product type is required'),
		imageUrls: yup
			.array()
			.min(1, 'Atleast 1 image is required')
			.required('Images are required.'),
		daysRequiredForDelivery: yup.object({
			early: yup
				.number()
				.min(1, 'Delivery date cannot be less than 1')
				.required('Early delivery date is required'),
			late: yup
				.number()
				.min(
					yup.ref('early'),
					'Late delivery date cannot be less than early delivery'
				)
				.required('Late delivery date is required'),
		}),
		availableWindow: yup.object({
			startHour: yup.number().when('$type', {
				is: 'SERVICE',
				then: yup
					.number()
					.min(1, 'Start time cannot be less than 1:00HRS')
					.max(24, 'Start time cannot be more than 24:00HRS')
					.required('Start time is required'),
				otherwise: yup.number(),
			}),
			endHour: yup.number().when('$type', {
				is: 'SERVICE',
				then: yup
					.number()
					.min(1, 'End time cannot be less than 1:00HRS')
					.max(24, 'End time cannot be more than 24:00HRS')
					.required('End time is required'),
				otherwise: yup.number(),
			}),
		}),
		availableDays: yup.array().when('$type', {
			is: 'SERVICE',
			then: yup
				.array()
				.min(1, 'Select at least 1 day your service is available')
				.required('Available days are required'),
			otherwise: yup.array(),
		}),
	});

	const validationSchema = stepOneValidation
		.concat(stepTwoValidation)
		.concat(stepThreeValidation);

	return { validationSchema };
};

export default useProductFormValidationSchema;
